// extracted by mini-css-extract-plugin
module.exports = {"SkillWrapper":"SkillSection-module--SkillWrapper--pCSPz","Skill":"SkillSection-module--Skill--3I25l","SkillText":"SkillSection-module--SkillText--15qLr"};